import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import BooleanFormatter from '../BooleanFormatter';

const String1Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.parameterList} /></h4>
        <table className="table table-sm">
            <tbody>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.sentimentAnalysis} /></th>
                    <td><BooleanFormatter value={question.sentimentAnalysis} /></td>
                </tr>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.entityExtraction} /></th>
                    <td><BooleanFormatter value={question.entityExtraction} /></td>
                </tr>
            </tbody>
        </table>
    </>
);

String1Type.propTypes = {
    question: PropTypes.object.isRequired,
};

export default String1Type;
